var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarNavyBlueOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55556 0C3.8317 0 4.05556 0.223858 4.05556 0.5V1.3H7.94444V0.5C7.94444 0.223858 8.1683 0 8.44444 0C8.72059 0 8.94444 0.223858 8.94444 0.5V1.3H10.2778C11.2575 1.3 12 2.1354 12 3.1V12.2C12 13.1646 11.2575 14 10.2778 14H1.72222C0.742454 14 0 13.1646 0 12.2V3.1C0 2.1354 0.742453 1.3 1.72222 1.3H3.05556V0.5C3.05556 0.223858 3.27941 0 3.55556 0ZM3.05556 2.3H1.72222C1.35196 2.3 1 2.62866 1 3.1V5.2H11V3.1C11 2.62866 10.648 2.3 10.2778 2.3H8.94444V3.1C8.94444 3.37614 8.72059 3.6 8.44444 3.6C8.1683 3.6 7.94444 3.37614 7.94444 3.1V2.3H4.05556V3.1C4.05556 3.37614 3.8317 3.6 3.55556 3.6C3.27941 3.6 3.05556 3.37614 3.05556 3.1V2.3ZM11 6.2H1V12.2C1 12.6713 1.35196 13 1.72222 13H10.2778C10.648 13 11 12.6713 11 12.2V6.2Z",
    fill: "#333541"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarNavyBlueOutline);
export default __webpack_public_path__ + "static/media/calendarNavyBlueOutline.b9852567243a25cfb4404200cf5fef6c.svg";
export { ForwardRef as ReactComponent };